// extracted by mini-css-extract-plugin
export default {"cls1":"Pagination-PaginationSkeleton_cls1__ASX+0","cls2":"Pagination-PaginationSkeleton_cls2__OQTxS Pagination-PaginationSkeleton_cls1__ASX+0"};